import styled from 'styled-components';

const LoginBtnHome = styled.button`
  cursor: pointer;
  width: 200px;
  height: 80px;
  border: 1px solid black;
  border-radius: 20px;
  background-color: #F0DB4F;
  font-size: 30px;

  &:hover {
    opacity: 0.8;
  }
  &:active {
    opacity: 0.8;
  }
`

export { LoginBtnHome }